import { createPluginRegistry } from '@ff-os/shared-utils/createPluginRegistry';
import { Pdp } from './Pdp';

export const scenePlugins = createPluginRegistry<Pdp.Scene.Plugin<any>>();